const PLANILHA_ID = "1LRBI178V3LQn5cBtV8eeh4TgZde4iS4RuUB1_1aCdI4";

export const PROMOCOES_URL =
  `https://docs.google.com/spreadsheets/d/${PLANILHA_ID}` +
  "/gviz/tq?tqx=out:json&sheet=promocoes";

function extrairJsonGviz(resposta) {
  const inicio = resposta.indexOf("{");
  const fim = resposta.lastIndexOf("}");

  if (inicio === -1 || fim === -1) {
    throw new Error("A planilha retornou um formato inesperado.");
  }

  return JSON.parse(resposta.slice(inicio, fim + 1));
}

function valorCelula(celula) {
  return celula?.v ?? null;
}

export function normalizarLinkImagem(link) {
  if (!link) return "";

  try {
    const url = new URL(String(link).trim());

    if (url.hostname === "drive.google.com") {
      const idNoCaminho = url.pathname.match(/\/file\/d\/([^/]+)/)?.[1];
      const id = idNoCaminho || url.searchParams.get("id");

      if (id) {
        return `https://drive.google.com/uc?export=view&id=${id}`;
      }
    }

    return url.href;
  } catch {
    return "";
  }
}

export function interpretarPromocoes(resposta) {
  const dados = extrairJsonGviz(resposta);

  if (dados.status !== "ok") {
    throw new Error("Não foi possível consultar a aba de promoções.");
  }

  return (dados.table?.rows || [])
    .map((linha, index) => {
      const celulas = linha.c || [];
      const preco = Number(valorCelula(celulas[1]));

      return {
        id: `promocao-${index + 1}`,
        imagem: normalizarLinkImagem(valorCelula(celulas[0])),
        preco: Number.isFinite(preco) ? preco : 0,
        descontos: {
          pix: Number(valorCelula(celulas[2])) || 0,
          cartao: Number(valorCelula(celulas[3])) || 0,
          dinheiro: Number(valorCelula(celulas[4])) || 0,
        },
      };
    })
    .filter(
      (promocao) =>
        promocao.imagem ||
        promocao.preco > 0 ||
        Object.values(promocao.descontos).some((desconto) => desconto > 0),
    );
}

export function calcularPrecoComDesconto(preco, desconto) {
  return Math.max(0, preco * (1 - desconto));
}

export async function carregarPromocoes({ signal } = {}) {
  const resposta = await fetch(PROMOCOES_URL, {
    cache: "no-store",
    signal,
  });

  if (!resposta.ok) {
    throw new Error("Não foi possível carregar as promoções.");
  }

  return interpretarPromocoes(await resposta.text());
}
